import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.whiteish,
  tileBgColor: colors.duskBlue,
  iconBgColor: colors.graphite
};
export default imageGallery;